import React, { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteItem, deleteMultipleItem, fetchData, toggleStatus } from "../../../utils/apiUtils";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import { ActionButton, checkImage, ColumnAdjust, DeleteButton, PlusButton, ToggleSwitch } from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import { toast } from "react-toastify";
import axiosInstance from "../../../axiosInterceptor";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../helper/Breadcrumb";
import { catalogueColumnsList } from "../../../Data/columnsData";
import ColumnVisibilitySidebar from "../../../Components/ColumnVisibilitySidebar";
import { formatDate } from "../../../utils/constants";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import BackButton from "../../../Components/BackButton";

const Catalogue = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigator = useNavigate();
  const editdata = location.state;
  const [loading, setLoading] = useState(true);
  const [catalogData, setCatalogData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [selected, setSelected] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [columnsList, setColumnsList] = useState(catalogueColumnsList);

  useEffect(() => {
    RemoveDraftProduct();
  }, []);



  const fetchCatelogData = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      category_id: id,
      search: searchQuery,
    };
    await fetchData(
      "catalogue-pagination",
      requestData,
      setCatalogData,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

  const RemoveDraftProduct = async () => {
    try {
      const response = await axiosInstance.get("draft-product");
      if (response?.status === 200) {
        const { data } = response?.data;
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Something went wrong. Please try again!!"
      );
    }
  };

  const handleToggleColumn = (key) => {
    setColumnsList((prev) =>
      prev.map((col) =>
        col.key === key ? { ...col, visible: !col.visible } : col
      )
    );
  };


  useEffect(() => {
    const delay = search ? 500 : 0;

    const handler = setTimeout(() => {
      fetchCatelogData(currentPage, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage]);


  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchCatelogData(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("catalogue", deleteItemId?.id, fetchCatelogData);
      setDeleteItemId({});
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };




  const handleStatusToggle = async (item) => {
    const data = await toggleStatus(
      `catalogue-status`,
      item?.id,
      fetchCatelogData
    );
    if (Object.keys(data).length > 0) {
      setCatalogData((prevdata) =>
        prevdata.map((curr) =>
          curr.id === data.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const handleEditClick = (data) => {
    navigator(`/catalogue-add/${id}`, {
      state: {
        ...editdata,
        catlogId: data?.id,
        update: true,
      },
    });
  };

  const handleBulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Sizes",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("catalogue-bulk-delete", ids),
      refreshCallback: fetchCatelogData,
    });
  };



  const isAllSelected =
    catalogData.length > 0 && selected.length === catalogData.length;
  const toggleSelectAll = () =>
    setSelected(isAllSelected ? [] : catalogData.map((i) => i.id));
  const toggleSelectOne = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );


 

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Category", path: "/category" },
    { label: "Catalogue", path: "" },
  ];
  const handleAdd = () => {
    navigator(`/catalogue-add/${id}`, {
      state: editdata,
    });
  };


  const renderCell = (col, data) => {
    switch (col.key) {
      case "image":
        return (
          <span style={{ cursor: "pointer" }}>{checkImage(data?.coverImage)}</span>
        );
      case "name":
        const displayTitle = data.name.length > 20 ? data.name.slice(0, 20) + "..." : data.name;
        return <span title={data.name}>{displayTitle}</span>;
      case "sku":
        return data?.cat_code;
      case "price":
        return `${data?.price?.toFixed(2)}`;
      case "discount":
        return data?.catalogue_discount ? `${data?.catalogue_discount} %` : "-";

      case "avg price":
        return data?.average_price ? `${data?.average_price}` : "-";

      case "offer price":
        return data?.offer_price ? `${data?.offer_price}` : "-";
      case "product":
        return (
          <button
            type="button"
            className="count-button1"
            onClick={() =>
              navigator(`/catalogue-products/${data.id}`, { state: data })
            }
          >
            {data._count?.Product}
          </button>
        )
      case "status":
        return (
          <ToggleSwitch
            data={data}
            name="isActive"
            checked={data.isActive}
            handleStatusToggle={handleStatusToggle}
            module={"catalogue"}
          />
        );
      case "action":
        return (
          <ActionButton
            data={data}
            handleEditClick={handleEditClick}
            handleDelete={handleDelete}
            module={"catalogue"}
          />
        );
      case "createdAt":
        return formatDate(data.createdAt);
      case "updatedAt":
        return formatDate(data.updatedAt);
      default:
        return data[col.key] || "-";
    }
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Catalogue</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div
          className="d-flex justify-content-between mb-3"
          style={{ background: "#fff", padding: "10px" }}
        >
         <PerPageSelect value={perPage} onChange={setPerPage}/>

          <div style={{ display: "flex", gap: "20px" }}>
            <BackButton to={"/category"}/>
          <TableSearch value={search} onChange={setSearch} />
            <PlusButton handleAdd={handleAdd} module={"catalogue"} />
            {/* <Back handleBack={() => navigator("/category")} /> */}
            <ColumnAdjust handleOpen={() => setSidebarOpen(true)} />
            {selected.length > 0 && (
              <DeleteButton
                handleAdd={handleBulkDelete}
                name="selected Catalogue"
                module={"Catalogue"}
              />
            )}

          </div>
        </div>

        <div className="row" style={{ marginTop: "-10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive rounded p-1">
                  <table
                    className="custom-table table table-striped"
                    id="catalogueTable"
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            ref={(el) => {
                              if (el)
                                el.indeterminate = selected.length > 0 && !isAllSelected;
                            }}
                            onChange={toggleSelectAll}
                          />
                        </th>
                        {columnsList
                          .filter((col) => col.visible)
                          .map((col) => (
                            <th key={col.key}>{col.label}</th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="11" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : catalogData?.length > 0 ? (
                        catalogData.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selected.includes(item.id)}
                                onChange={() => toggleSelectOne(item.id)}
                              />
                            </td>
                            {columnsList
                              .filter((col) => col.visible)
                              .map((col) => (
                                <td key={col.key}>{renderCell(col, item)}</td>
                              ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            <h4>No data available</h4>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {catalogData?.length > 0 && (
                  <div>
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="Catalogue"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}

      {sidebarOpen && (
        <ColumnVisibilitySidebar
          columns={columnsList}
          onToggle={handleToggleColumn}
          onClose={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
};

export default Catalogue;
